import {useEffect} from 'react'
import {http} from '../shared/http'
import {useSharedStore} from '../state/shared-store-context'
import {isLoggedIn} from '../shared/session'

export function useNotificationSettings() {
    const {actions, sharedState} = useSharedStore()

    useEffect(() => {
        if (!isLoggedIn() || sharedState.notificationSettings !== null) return
        http.get('/api/v1/profile').then(r => {
            if (r.data?.user?.notifications) actions.setNotificationSettings(r.data.user.notifications)
        }).catch(() => {})
    }, [isLoggedIn()])

    return sharedState.notificationSettings
}
